import Vue from 'vue'
import { sync } from 'vuex-router-sync'
import VueRouter from 'vue-router'
import store from './store/index'
import { setupWebViewJavascriptBridge } from './assets/js/util'
// import { getQueryString } from './assets/js/util'
import Enterprise from './pages_enterprise/Enterprise'
/**
 *  重新全部使用模块加载的形式
 * */

Vue.use(VueRouter)

// 路由
const router = new VueRouter({
  base: '/baoche_frontend/dist',
  mode: 'history',
  routes: [{
    name: 'home',
    path: '/',
    // component: OrderVehicle,
    component: function (resolve) {
      require(['./pages/OrderVehicle'], resolve)
    },
    meta: {
      title: '包车下单',
      need_login: false
    }
  }, {
    name: 'orderVehicle',
    path: '/orderVehicle',
    // component: OrderVehicle,
    component: function (resolve) {
      require(['./pages/OrderVehicle'], resolve)
    },
    meta: {
      title: '包车下单',
      need_login: false
    }
  }, {
    path: '/search/:type/:index',
    // component: RouteAddress,
    component: function (resolve) {
      require(['./pages/RouteAddress'], resolve)
    },
    meta: {
      title: '包车下单',
      need_login: false
    }
  }, {
    path: '/search/:type',
    // component: RouteAddress,
    component: function (resolve) {
      require(['./pages/RouteAddress'], resolve)
    },
    meta: {
      title: '包车下单',
      need_login: false
    }
  }, {
    name: 'selectBus',
    path: '/select/bus',
    // component: SelectBus,
    component: function (resolve) {
      require(['./pages/SelectBus'], resolve)
      // require(['./pages/SelectBus_back'], resolve)
    },
    meta: {
      title: '请选择车辆',
      need_login: true
    }
  }, {
    name: 'confirmOrder',
    path: '/confirmOrder',
    component: function (resolve) {
      require(['./pages/confirmOrder'], resolve)
    },
    meta: {
      title: '填写信息',
      need_login: true
    }
  }, {
    name: 'orderDetail',
    path: '/orderDetail/:orderId',
    // component: OrderDetail,
    component: function (resolve) {
      require(['./pages/OrderDetail'], resolve)
    },
    meta: {
      title: '订单详情',
      need_login: true
    }
  }, {
    name: 'orderDetailRo',
    path: '/orderDetailRo/:orderId',
    // component: OrderDetailRo,
    component: function (resolve) {
      require(['./pages/OrderDetailRo'], resolve)
    },
    meta: {
      title: '订单详情',
      need_login: false
    }
  }, {
    name: 'commitSuccess',
    path: '/commitSuccess/:orderId',
    // component: CommitSuccess,
    component: function (resolve) {
      require(['./pages/CommitSuccess'], resolve)
    },
    meta: {
      title: '提交成功',
      need_login: true
    }
  }, {
    name: 'login',
    path: '/login',
    // component: Login,
    component: function (resolve) {
      require(['./pages/Login'], resolve)
    },
    meta: {
      title: '登录',
      need_login: false
    }
  }, {
    name: 'author',
    path: '/author',
    component: function (resolve) {
      require(['./pages/Author'], resolve)
    },
    meta: {
      title: '授权',
      need_login: false
    }
  }, {
    name: 'pay',
    path: '/pay/:orderId/:payState',
    // component: Pay,
    component: function (resolve) {
      require(['./pages/Pay'], resolve)
    },
    meta: {
      title: '支付页面',
      need_login: true
    }
  }, {
    name: 'paySuccess',
    path: '/paySuccess/:orderId',
    // component: PaySuccess,
    component: function (resolve) {
      require(['./pages/PaySuccess'], resolve)
    },
    meta: {
      title: '支付成功',
      need_login: true
    }
  }, {
    name: 'myOrder',
    path: '/myOrder',
    // component: MyOrder,
    component: function (resolve) {
      require(['./pages/MyOrder'], resolve)
    },
    meta: {
      title: '我的订单',
      need_login: true
    }
  }, {
    name: 'coupon',
    path: '/coupon/:type',
    // component: Coupon,
    component: function (resolve) {
      require(['./pages/Coupon'], resolve)
    },
    meta: {
      title: '优惠卡劵',
      need_login: true
    }
  }, {
    name: 'selectCoupon',
    path: '/chooseCoupon/:type/:orderId',
    // component: Coupon,
    component: function (resolve) {
      require(['./pages/Coupon'], resolve)
    },
    meta: {
      title: '选择优惠卡券',
      need_login: true
    }
  }, {
    name: 'historyCoupon',
    path: '/historyCoupon',
    // component: HistoryCoupon,
    component: function (resolve) {
      require(['./pages/HistoryCoupon'], resolve)
    },
    meta: {
      title: '历史券',
      need_login: true
    }
  }, {
    name: 'question',
    path: '/question',
    // component: UsualQuestion,
    component: function (resolve) {
      require(['./pages/UsualQuestion'], resolve)
    },
    meta: {
      title: '常见问题',
      need_login: false
    }
  }, {
    name: 'service',
    path: '/service',
    // component: ServiceAgreement,
    component: function (resolve) {
      require(['./pages/ServiceAgreement'], resolve)
    },
    meta: {
      title: '服务协议',
      need_login: false
    }
  }, {
    name: 'rater',
    path: '/rater/:type/:orderId',
    component: function (resolve) {
      require(['./pages/AppRater'], resolve)
    },
    meta: {
      title: '评价',
      need_login: true
    }
  }, {
    name: 'introduce2',
    path: '/introduce2',
    // component: Introduce2,
    component: function (resolve) {
      require(['./pages/Introduce2'], resolve)
    },
    meta: {
      title: '包车找嘟嘟',
      need_login: false
    }
  }, {
    name: 'selectCity',
    path: '/selectCity',
    component: function (resolve) {
      require(['./pages/selectCity'], resolve)
    },
    meta: {
      title: '选择城市',
      need_login: false
    }
  }, {
    path: '/e/:enterprise_id', // 企业端 开始
    name: 'enterprise',
    component: Enterprise,
    meta: {
      need_login: false
    },
    children: [{
      name: 'home',
      path: '/',
      component: function (resolve) {
        require(['./pages_enterprise/OrderVehicle'], resolve)
      },
      meta: {
        title: '包车下单',
        need_login: false
      }
    }, {
      name: 'orderVehicle',
      path: 'orderVehicle',
      component: function (resolve) {
        require(['./pages_enterprise/OrderVehicle'], resolve)
      },
      meta: {
        title: '包车下单',
        need_login: false
      }
    }, {
      path: 'search/:type/:index',
      component: function (resolve) {
        require(['./pages/RouteAddress'], resolve)
      },
      meta: {
        title: '包车下单',
        need_login: false
      }
    }, {
      path: 'search/:type',
      component: function (resolve) {
        require(['./pages/RouteAddress'], resolve)
      },
      meta: {
        title: '包车下单',
        need_login: false
      }
    }, {
      name: 'selectBus',
      path: 'select/bus',
      component: function (resolve) {
        require(['./pages_enterprise/SelectBus'], resolve)
      },
      meta: {
        title: '请选择车辆',
        need_login: true
      }
    }, {
      name: 'confirmOrder',
      path: 'confirmOrder',
      component: function (resolve) {
        require(['./pages_enterprise/confirmOrder'], resolve)
      },
      meta: {
        title: '填写信息',
        need_login: true
      }
    }, {
      name: 'orderDetail',
      path: 'orderDetail/:orderId',
      component: function (resolve) {
        require(['./pages_enterprise/OrderDetail'], resolve)
      },
      meta: {
        title: '订单详情',
        need_login: true
      }
    }, {
      name: 'orderDetailRo',
      path: 'orderDetailRo/:orderId',
      component: function (resolve) {
        require(['./pages/OrderDetailRo'], resolve)
      },
      meta: {
        title: '订单详情',
        need_login: false
      }
    }, {
      name: 'commitSuccess',
      path: 'commitSuccess/:orderId',
      component: function (resolve) {
        require(['./pages_enterprise/CommitSuccess'], resolve)
      },
      meta: {
        title: '提交成功',
        need_login: true
      }
    }, {
      name: 'login',
      path: 'login',
      component: function (resolve) {
        require(['./pages/Login'], resolve)
      },
      meta: {
        title: '登录',
        need_login: false
      }
    }, {
      name: 'author',
      path: 'author',
      component: function (resolve) {
        require(['./pages/Author'], resolve)
      },
      meta: {
        title: '授权',
        need_login: false
      }
    }, {
      name: 'pay',
      path: 'pay/:orderId/:payState',
      component: function (resolve) {
        require(['./pages/Pay'], resolve)
      },
      meta: {
        title: '支付页面',
        need_login: true
      }
    }, {
      name: 'paySuccess',
      path: 'paySuccess/:orderId',
      component: function (resolve) {
        require(['./pages/PaySuccess'], resolve)
      },
      meta: {
        title: '支付成功',
        need_login: true
      }
    }, {
      name: 'myOrder',
      path: 'myOrder',
      component: function (resolve) {
        require(['./pages_enterprise/MyOrder'], resolve)
      },
      meta: {
        title: '我的订单',
        need_login: true
      }
    }, {
      name: 'coupon',
      path: 'coupon/:type',
      component: function (resolve) {
        require(['./pages/Coupon'], resolve)
      },
      meta: {
        title: '优惠卡劵',
        need_login: true
      }
    }, {
      name: 'selectCoupon',
      path: 'chooseCoupon/:type/:orderId',
      component: function (resolve) {
        require(['./pages/Coupon'], resolve)
      },
      meta: {
        title: '选择优惠卡券',
        need_login: true
      }
    }, {
      name: 'historyCoupon',
      path: 'historyCoupon',
      component: function (resolve) {
        require(['./pages/HistoryCoupon'], resolve)
      },
      meta: {
        title: '历史券',
        need_login: true
      }
    }, {
      name: 'question',
      path: 'question',
      component: function (resolve) {
        require(['./pages/UsualQuestion'], resolve)
      },
      meta: {
        title: '常见问题',
        need_login: false
      }
    }, {
      name: 'service',
      path: 'service',
      component: function (resolve) {
        require(['./pages/ServiceAgreement'], resolve)
      },
      meta: {
        title: '服务协议',
        need_login: false
      }
    }, {
      name: 'rater',
      path: 'rater/:type/:orderId',
      component: function (resolve) {
        require(['./pages/AppRater'], resolve)
      },
      meta: {
        title: '评价',
        need_login: true
      }
    }, {
      name: 'introduce2',
      path: 'introduce2',
      component: function (resolve) {
        require(['./pages_enterprise/Introduce2'], resolve)
      },
      meta: {
        title: '用车流程',
        need_login: false
      }
    }, {
      name: 'selectCity',
      path: 'selectCity',
      component: function (resolve) {
        require(['./pages/selectCity'], resolve)
      },
      meta: {
        title: '选择城市',
        need_login: false
      }
    }]
  }]
})

let history = window.sessionStorage
let historyCount = history.getItem('count') * 1 || 0
let init_dudu_app = false
let init_h5 = false
let init_wx = false
let init_page_router = false // 是否初始化页面路由
history.setItem('/', 0)

function initWX () {
  // 判断是否在微信环境下
  if (!init_wx && store.getters.is_weixin_browser) {
    init_wx = true
    // 获取参数
    setTimeout(function () {
      store.dispatch('wxShare')
    }, 100)
  }
}

function setPatch (patch) {
  // 路由跳转，根据是否是企业端进行跳转不同的页面
  var _patch = patch
  if (store.getters.enterprise_id) {
    _patch = '/e/' + store.getters.enterprise_id + _patch
  }
  return _patch
}
router.beforeEach((to, from, next) => {
  if (!init_page_router && to.params.enterprise_id) {
    // 更新企业id
    store.commit('UPDATE_ENTERPRISE_ID', to.params.enterprise_id)
    init_page_router = true
  }
  if ((to.query.os === '25' || to.query.os === '28') && to.name === 'home' && !store.getters.is_login && (!to.query.check_author || to.query.check_author !== 'no')) {
    // 针对左岭进行授权处理 25 (中天) 28 （深圳湾）
    getAuthor(to)
  } else if (store.getters.enterprise_id && !to.params.enterprise_id) {
    // 根据如果存在企业id则直接跳转到企业相关页面下
    router.push({
      path: setPatch(to.path),
      query: to.query
    })
    next()
  } else if (to.name === 'author') {
    next()
  } else {
    goNext()
  }
  function getAuthor (to) {
    // 授权登录跳转
    window.localStorage.setItem('from_query', JSON.stringify(to.query)) // 缓存参数
    var _client_id = ''
    var _site = ''
    var _redirect_uri = (window.location.href.split('?'))[0]
    _redirect_uri = _redirect_uri.charAt(_redirect_uri.length - 1) === '/' ? encodeURIComponent(_redirect_uri + setPatch('author')) : encodeURIComponent(_redirect_uri + setPatch('/author'))
    if (to.query.os === '25') {
      _client_id = 'ce48c658-46bb-48e4-8ecc-99d2c375c6c2'
      _site = 'https://core.zuolin.com/evh/oauth2/authorize'
    } else if (to.query.os === '28') {
      _client_id = '3130b2c3-2cb0-4fe7-9b35-4440a6fe0c84'
      _site = 'https://park.szbay.com/evh/oauth2/authorize'
    }
    window.location.href = _site + '?response_type=code&client_id=' + _client_id + '&redirect_uri=' + _redirect_uri + '&scope=basic&state=dudubashi_baoche#oauth2_redirect'
  }
  // 进行下一步
  function goNext () {
    // 判断路径，一些禁止跳转的
    if ((from.name === 'pay' || from.name === 'commitSuccess' || from.name === 'orderDetail' || from.name === 'orderDetailRo') && to.name === 'selectBus') {
      // 不允许从支付成功页面跳转到选择车辆页面
      router.replace({path: setPatch('/orderVehicle')})
      next()
    }
    // 设置动画切换方向，页面来源，返回地址
    const toIndex = history.getItem(to.path)
    const fromIndex = history.getItem(from.path)
    // if (to.name !== 'home' && to.name !== 'introduce') {
    //   window.localStorage.setItem('isUsedCharter', 'used')
    // }
    if (toIndex) {
      if (toIndex > fromIndex || !fromIndex) {
        store.commit('UPDATE_DIRECTION', 'forward')
      } else {
        store.commit('UPDATE_DIRECTION', 'reverse')
      }
    } else {
      ++historyCount
      history.setItem('count', historyCount)
      to.path !== '/' && history.setItem(to.path, historyCount)
      store.commit('UPDATE_DIRECTION', 'forward')
    }
    if (from.path) {
      store.commit('UPDATE_PAGE_FROM', from.path)
    }
    store.commit('UPDATE_LOADING', true)
    for (var i = 0, _inputs = document.getElementsByTagName('input'), len = _inputs.length; i < len; i++) {
      _inputs[0].blur()
    }
    var _back_url = to.path !== '/' ? from.path : null
    switch (to.name) {
      case 'myOrder':
        _back_url = '/orderVehicle'
        break
      case 'selectBus':
        _back_url = '/orderVehicle'
        break
      case 'confirmOrder':
        _back_url = '/orderVehicle'
        break
      case 'orderDetail':
        if (from.name !== 'myOrder') {
          _back_url = '/myOrder'
        }
        break
      case 'coupon':
        if (from.name === 'historyCoupon') {
          _back_url = '/orderVehicle'
        }
        break
      case 'orderVehicle':
        _back_url = null
        break
      case 'paySuccess':
        _back_url = null
        break
      case 'login':
        if (store.getters.is_login) {
          router.replace('/orderVehicle')
        }
        break
    }
    store.commit('UPDATE_BACK_PATH', setPatch(_back_url))

    // 设置APP基本参数
    if (to.query.os === '1' || to.query.os === '2') {
      if (!init_dudu_app) {
        init_dudu_app = true
        store.dispatch('setAppParams', to.query)
        store.dispatch('setUserInfo', to.query)
      }
    } else if (to.query.os) {
      store.dispatch('setOS', to.query.os)
    }

    // 设置app 标题及右上角按钮显示
    if (init_dudu_app) {
      if (store.getters.os === '1') {
        setupWebViewJavascriptBridge(function (bridge) {
          bridge.callHandler('setNavigationBarTitle', to.meta ? to.meta.title : '')
        })
        // app内隐藏热门咨询标题
        if (to.name === 'orderVehicle' || to.name === 'home' && to.query.firstuse !== '1') {
          setupWebViewJavascriptBridge(function (bridge) {
            bridge.callHandler('showRightBarButtonItem', {show: '1'})
          })
        } else {
          setupWebViewJavascriptBridge(function (bridge) {
            bridge.callHandler('showRightBarButtonItem', {show: '0'})
          })
        }
      } else if (store.getters.os === '2') {
        try {
          window.app.setNavigationBarTitle(to.meta ? to.meta.title : '')
        } catch (e) {
          console.warn('== 出现错误, 如果在非android环境下访问, 出现该警告是正常的.')
        }
        if (to.name === 'orderVehicle' || to.name === 'home' && to.query.firstuse !== '1') {
          try {
            window.app.showRightBarButtonItem('1')
          } catch (e) {
            console.warn('== 出现错误, 如果在非android环境下访问, 出现该警告是正常的.')
          }
        } else {
          try {
            window.app.showRightBarButtonItem('0')
          } catch (e) {
            console.warn('== 出现错误, 如果在非android环境下访问, 出现该警告是正常的.')
          }
        }
      }
    }
    // 是否加载微信分享
    if (!init_wx) {
      init_wx = true
      initWX()
    }
    if (store.getters.is_app) {
      setTimeout(next, 50)
    } else {
      if (to.meta.need_login) {
        // 第一次访问，自动获取登录信息
        if (!init_h5 && !store.getters.is_login) {
          init_h5 = true
          const _result = store.dispatch('autoLogin')
          _result.then(function (_res) {
            // 用户未登入
            if (!_res.data.login && to.name !== 'orderVehicle' && to.name !== 'home' && to.name !== 'question' && to.name !== 'introduce2') {
              var _query = to.query
              _query.backurl = to.path.split('/')[1]
              _query.routeurl = to.params
              // 短信直接跳转打开的页面
              if (window.location.href.indexOf('refer=sms') !== -1) {
                window.localStorage.setItem('refer', 'sms')
              }
              router.replace({path: setPatch('/login'), query: _query})
            }
            next()
          })
        } else {
          if (store.getters.is_login) {
            next()
          } else {
            var _query = to.query
            _query.backurl = to.path.split('/')[1]
            _query.routeurl = to.params
            router.replace({path: setPatch('/login'), query: _query})
          }
        }
      } else {
        if (!init_h5 && !store.getters.is_login) {
          init_h5 = true
          store.dispatch('autoLogin')
        }
        next()
      }
    }
  }
})

router.afterEach(() => {
  store.commit('UPDATE_LOADING', false)
})

sync(store, router)

export default router



// WEBPACK FOOTER //
// ./src/router.js